<template>
	<div class="container">
		<div>code:{{ vxCode }}</div>
		<div class="btn" @click="handleEnroll">点击获取code</div>
	</div>
</template>

<script>
var that;
export default {
	name: 'LoginIndex',
	components: {},
	props: {},
	data() {
		return {
			vxCode: '',
		}
	},
	computed: {},
	watch: {},
	created() {
		that = this
		//有code去登录
		const queryObj = this.getQueryObj()
		if (queryObj['code']) {
			that.vxCode = queryObj['code'];
		}

	},
	methods: {

		handleEnroll() {
			console.log('获取vx授权code')
			window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd06acaafd7167053&redirect_uri=${encodeURIComponent(window.location.href)}&response_type=code&scope=snsapi_userinfo#wechat_redirect`)
		},

		// 获取地址栏的参数
		getQueryObj() {
			var query = window.location.search
			var queryObj = {}
			var arr = query.slice(1, query.length).split('&')
			arr.forEach(function (val) {
				var arr1 = val.split('=')
				queryObj[arr1[0]] = arr1[1]
			})
			return queryObj
		},


	}
}
</script>

<style scoped lang="less"></style>